export const LOAN_TRANSACTION_HEADERS: Readonly<{
	text: string;
	align?: string;
	value: string;
	sortable?: boolean;
}>[] = [
	{
		text: 'Date',
		align: 'start',
		sortable: false,
		value: 'effectiveDate',
	},
	{
		text: 'Status',
		sortable: false,
		value: 'status',
	},
	{
		text: 'Description',
		sortable: false,
		value: 'description',
	},
	{
		text: 'Type',
		sortable: false,
		value: 'transactionType',
	},
	{
		text: 'Amount',
		sortable: false,
		value: 'amount',
	},
	{
		text: 'Loan Balance',
		sortable: false,
		value: 'principalBalance',
	},
	{
		text: 'Available To Take-Back',
		sortable: false,
		value: 'availableToWithdraw',
	},
];
